window._ = require("lodash");

import store from "./store";

try {
    require("bootstrap");
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

// Globally define the base URL for Axios to use on all future requests
window.axios.defaults.baseURL = store.state.global.global.app.url + "api/v1"; // Relative to the current HTTP host

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

var originalRequest = false;
window.axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // If an API endpoint returns with a 401 Unauthorized response, then lets clear the user's browser storage, clear state and redirect to login page.
        // console.log(error.config.url);
        console.log(error.response);
        if ((error.response != undefined && error.response.status === 401) && error.config.url != "/auth/login" && !originalRequest) {
            originalRequest = true; // now it can be retried

            window.localStorage.clear(); //
            store.state.user.user.session_token = undefined;
            store.state.user.user.loggedIn = false;
            window.location = "/login";
        }
        return Promise.reject(error);
    }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
